function routeBusStopMapTarget (routeBusStop) {
  if (!routeBusStop || !routeBusStop.longlat || !routeBusStop.longlat.length) {
    return null
  }

  return {
    id: routeBusStop.id,
    longLat: routeBusStop.longlat.slice()
  }
}

module.exports = {
  routeBusStopMapTarget
}
